import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MeetingRating from "./MeetingRating";
import {juniorListForImmediateSenior, saveTheMeetingRating, fetchRatingEmailDropdown } from "services/redux/brandActivtion/meetings/action";

const mapStateToProps = (state) => ({
    getJuniorListForImmediateSenior: state.baMeetingReducer.getJuniorListForImmediateSenior,
    saveMeetingRatingByImmediateSenior: state.baMeetingReducer.saveMeetingRatingByImmediateSenior,
    emailDropdownFilter: state.baMeetingReducer.emailDropdownFilter,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      juniorListForImmediateSenior,
      saveTheMeetingRating,
      fetchRatingEmailDropdown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MeetingRating);
